var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 88V16C8.5 13.8 9.284 11.916 10.852 10.348C12.42 8.78001 14.3027 7.99734 16.5 8.00001H80.5C82.7 8.00001 84.584 8.78401 86.152 10.352C87.72 11.92 88.5027 13.8027 88.5 16V64C88.5 66.2 87.716 68.084 86.148 69.652C84.58 71.22 82.6973 72.0027 80.5 72H24.5L8.5 88ZM38.1 56L48.5 45.6L58.9 56L64.5 50.4L54.1 40L64.5 29.6L58.9 24L48.5 34.4L38.1 24L32.5 29.6L42.9 40L32.5 50.4L38.1 56Z",
    fill: "#EDF1F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconError);
export default __webpack_public_path__ + "static/media/icon-error.75866f99d1b02f9fdd85045180ffd6b5.svg";
export { ForwardRef as ReactComponent };